import { useContext, useEffect, useState } from "react";
import { Select, Table, Row, Col } from "antd";
import moment from "moment";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { Context } from "../../context";
import { Fetch } from "../../fetch";
import { DatePicker, Space } from "antd/es";
import dayjs from 'dayjs';
import { convertIdToKey } from "../../utils";
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const { Column } = Table;
const dateFormat = "YYYY-MM-DD hh:mm:ss";

const RevenueReports = () => {
    const { token, apiUrl } = useContext(Context);
    const [filters, setFilters] = useState({
        start_date: null,
        end_date: null,
        plan: null,
        currency: null,
        platform: null,
    });
    const [data, setData] = useState([]);
    const [applePlans, setApplePlans] = useState([]);
    const [allPlans, setAllPlans] = useState([]);
    const [plans, setPlans] = useState([]);
    const generateQueryParams = (filters) => {
        const queryParams = new URLSearchParams();
        if (filters.start_date && filters.end_date) {
            queryParams.set("start_date", moment(filters.start_date).format(dateFormat));
            queryParams.set("end_date", moment(filters.end_date).format(dateFormat));
        }
        if (filters.platform) {
            queryParams.set("platform", filters.platform);
        }
        if (filters.currency) {
            queryParams.set("currency", filters.currency);
        }
        if (filters.plan) {
            queryParams.set("plan", filters.plan);
        }
        return queryParams;
    };

    useEffect(() => {
        const queryParams = generateQueryParams(filters);
        Fetch(`${apiUrl}/reports/revenue?${queryParams}`, token, (result) => {
            setData(result.reports);
        });
    }, [filters]);

    useEffect(() => {
        if ("length" in plans && plans.length === 0) {
            Fetch(`${apiUrl}/plans?type=web`, token, (result) => {
                const plans = convertIdToKey(result.plans);
                setPlans(plans);
            });
            Fetch(`${apiUrl}/plans?type=apple`, token, (result) => {
                const plans = convertIdToKey(result.plans);
                plans.forEach((plan) => {
                    plan.name = plan.planId;
                    plan.enrichedName = plan.name + " (Apple)";
                });
                setApplePlans(plans);
            });
        }
    }, [apiUrl, token, filters]);

    useEffect(() => {
        if (
            allPlans.length === 0 &&
            plans.length !== 0 &&
            applePlans.length !== 0
        ) {
            let temp_plans = [...plans, ...applePlans];
            setAllPlans(temp_plans);
        }
    }, [plans, applePlans]);


    const onRangeChange = (dates, dateStrings) => {
        if (dates) {
            console.log('From: ', dates[0], ', to: ', dates[1]);
            console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
        } else {
            console.log('Clear');
        }
    };
    const rangePresets = [
        {
            label: 'Last 7 Days',
            value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
            label: 'Last 14 Days',
            value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
            label: 'Last 30 Days',
            value: [dayjs().add(-30, 'd'), dayjs()],
        },
        {
            label: 'Last 90 Days',
            value: [dayjs().add(-90, 'd'), dayjs()],
        },
    ];

    const customfilters = (
        <>
            {" "}
            <Row style={{ marginBottom: "20px" }} align={"middle"}>
                {
                    <Space direction="vertical" size={12}>
                        <RangePicker
                            presets={[
                                {
                                    label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                                    value: () => [dayjs(), dayjs().endOf('day')], // 5.8.0+ support function
                                },
                                ...rangePresets,
                            ]}
                            showTime
                            format="YYYY/MM/DD HH:mm:ss"
                            onChange={onRangeChange}
                        />
                    </Space>
                }
                {
                    <>
                        <Col span={4}>
                            <Select
                                style={{ width: "100%" }}
                                placeholder={"Filter by Platform"}
                                allowClear
                                onChange={(v) => setFilters({ ...filters, platform: v })}
                            >
                                {["android", "ios", "web"].map((code) => (
                                    <Select.Option key={code} value={code}>
                                        {code}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <Select
                                style={{ width: "100%" }}
                                placeholder={"Filter by Currency"}
                                allowClear
                                onChange={(v) => setFilters({ ...filters, currency: v })}
                            >
                                {["INR", "USD"].map((code) => (
                                    <Select.Option key={code} value={code}>
                                        {code}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <Select
                                style={{ width: "100%" }}
                                placeholder={"Filter by Plan_name"}
                                allowClear
                                onChange={(v) => setFilters({ ...filters, plan: v })}
                            >
                                {allPlans && allPlans.map((plan, index) => {
                                    return (
                                        <Select.Option key={index} value={plan.name}>
                                            {plan.enrichedName ? plan.enrichedName : plan.name}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        </Col>
                    </>
                }
            </Row>
        </>
    );

    return (
        <div className="manage-orders-wrapper">
            {customfilters}
            <Table dataSource={data}>
                <Column
                    title="Amount"
                    dataIndex="amount"
                    key="user"
                    align="center"
                    render={(_, record) => (
                        <Space>
                            {record.pg !== "PhonePe"
                                ? `${record.amount} USD`
                                : `${record.amount} INR`}
                        </Space>
                    )}
                />
                <Column
                    title="No of Subscriptions"
                    dataIndex="subscriptions"
                    key="userCount"
                    align="center"
                    render={(text) => (text ? text : "NA")}
                />
                <Column
                    title="PG"
                    dataIndex="pg"
                    key="content"
                    align="center"
                    render={(text) => (text ? text : "NA")}
                />
            </Table>
        </div>
    );
};

export default RevenueReports;